/**
 * WooCommerce Product Bundles handler.
 *
 * Parses bundle_form fields into the bundle_configuration format
 * expected by the WC Product Bundles Store API extension.
 */
export default {
	matches(form) {
		return form.classList.contains('bundle_form');
	},

	buildApiData(form, formData) {
		const bundledItems = {};

		// Identify optional items via DOM (unchecked checkboxes are absent from FormData)
		const optionalItemIds = new Set();
		form.querySelectorAll('input[name^="bundle_selected_optional_"]').forEach(el => {
			const m = el.name.match(/^bundle_selected_optional_(\d+)$/);
			if (m) optionalItemIds.add(m[1]);
		});

		for (const [key, value] of formData.entries()) {
			let match;

			if ((match = key.match(/^bundle_quantity_(\d+)$/))) {
				const itemId = match[1];
				if (!bundledItems[itemId]) bundledItems[itemId] = { bundled_item_id: parseInt(itemId) };
				const qty = parseInt(value);
				bundledItems[itemId].quantity = isNaN(qty) ? 1 : qty;
			} else if ((match = key.match(/^bundle_variation_id_(\d+)$/))) {
				const itemId = match[1];
				if (!bundledItems[itemId]) bundledItems[itemId] = { bundled_item_id: parseInt(itemId) };
				const varId = parseInt(value) || 0;
				if (varId > 0) {
					bundledItems[itemId].variation_id = varId;
				}
			} else if ((match = key.match(/^bundle_(attribute_[^_]+(?:_[^_]+)*)_(\d+)$/))) {
				const attrName = match[1];
				const itemId = match[2];
				if (!bundledItems[itemId]) bundledItems[itemId] = { bundled_item_id: parseInt(itemId) };
				if (!bundledItems[itemId].attributes) bundledItems[itemId].attributes = [];
				bundledItems[itemId].attributes.push({
					name: attrName.replace('attribute_', ''),
					option: value
				});
			} else if ((match = key.match(/^bundle_selected_optional_(\d+)$/))) {
				const itemId = match[1];
				if (!bundledItems[itemId]) bundledItems[itemId] = { bundled_item_id: parseInt(itemId) };
				bundledItems[itemId].optional_selected = true;
			}
		}

		// Filter out unselected optional items and zero-quantity items
		const config = Object.values(bundledItems).filter(item => {
			const itemId = String(item.bundled_item_id);
			if (optionalItemIds.has(itemId) && item.optional_selected !== true) return false;
			if (item.quantity === 0) return false;
			return true;
		});

		if (config.length > 0) {
			return { bundle_configuration: config };
		}
		return null;
	}
};
